import { render, staticRenderFns } from "./faqMainPage.vue?vue&type=template&id=1643774e&scoped=true"
import script from "./faqMainPage.vue?vue&type=script&lang=js"
export * from "./faqMainPage.vue?vue&type=script&lang=js"
import style0 from "./faqMainPage.vue?vue&type=style&index=0&id=1643774e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643774e",
  null
  
)

export default component.exports